const collections = [
  {
    title: '暑期档必看大片',
    desc: '2026暑期热门影片一网打尽',
    count: '48部',
    icon: 'ri-sun-line',
    color: 'accent',
  },
  {
    title: '豆瓣高分精选',
    desc: '8分以上口碑佳作合集',
    count: '126部',
    icon: 'ri-star-line',
    color: 'primary',
  },
  {
    title: '经典港片回忆',
    desc: '那些年我们追过的港片',
    count: '89部',
    icon: 'ri-vidicon-line',
    color: 'secondary',
  },
  {
    title: '韩剧高分必刷',
    desc: '豆瓣高评韩剧一次看够',
    count: '64部',
    icon: 'ri-heart-line',
    color: 'accent',
  },
  {
    title: '国产悬疑剧场',
    desc: '烧脑悬疑让你欲罢不能',
    count: '37部',
    icon: 'ri-search-eye-line',
    color: 'primary',
  },
  {
    title: '动漫热血专场',
    desc: '日漫国漫热血番全收录',
    count: '215部',
    icon: 'ri-rocket-line',
    color: 'secondary',
  },
  {
    title: '奥斯卡获奖作品',
    desc: '历年奥斯卡最佳影片全集',
    count: '53部',
    icon: 'ri-award-line',
    color: 'accent',
  },
  {
    title: '纪录片精选',
    desc: '自然人文历史深度记录',
    count: '72部',
    icon: 'ri-earth-line',
    color: 'primary',
  },
];

export default function Index() {
  return (
    <section id="index" className="w-full py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            专题合集
          </h2>
          <p className="text-foreground-600 text-sm mt-2">精选优质内容，为你分门别类整理好每一部值得看的影视作品</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {collections.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer flex flex-col gap-3"
            >
              <span
                className={`w-10 h-10 flex items-center justify-center rounded-lg text-lg ${
                  item.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : item.color === 'primary'
                    ? 'bg-primary-100 text-primary-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={item.icon}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-0.5">{item.title}</h3>
                <p className="text-sm text-foreground-600">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded w-fit whitespace-nowrap mt-auto">
                {item.count} 资源
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}